// Author YuJiaBei
// Date 2021-06-07 15:49:36

class SithMesProProjectPlanDetailDepPpdd {
constructor({
        id = null,
        ppddIdOriginPpd = '',
        originProjectCode = '',
        originActivityId = '',
        ppddIdTargitPpd = '',
        targetProjectCode = '',
        targetActivityId = '',
        prpdType = '',
        prpdLagTime = '',
        remark = ''}
= {}) {
    this.id = id;
    this.ppddIdOriginPpd = ppddIdOriginPpd;
    this.originProjectCode = originProjectCode;
    this.originActivityId = originActivityId;
    this.ppddIdTargitPpd = ppddIdTargitPpd;
    this.targetProjectCode = targetProjectCode;
    this.targetActivityId = targetActivityId;
    this.prpdType = prpdType;
    this.prpdLagTime = prpdLagTime;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesProProjectPlanDetailDepPpdd();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ppddIdOriginPpd',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.ppddIdOriginPpd',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'originProjectCode',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.originProjectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'originActivityId',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.originActivityId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ppddIdTargitPpd',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.ppddIdTargitPpd',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'targetProjectCode',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.targetProjectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'targetActivityId',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.targetActivityId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prpdType',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.prpdType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prpdLagTime',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.prpdLagTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    ppddIdOriginPpdFilter : "",
    originProjectCodeFilter : "",
    originActivityIdFilter : "",
    ppddIdTargitPpdFilter : "",
    targetProjectCodeFilter : "",
    targetActivityIdFilter : "",
    prpdTypeFilter : "",
    prpdLagTimeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'ppddIdOriginPpdFilter',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.filter.ppddIdOriginPpd',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdProjectPlanDetailPpd'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'originProjectCodeFilter',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.filter.originProjectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'originActivityIdFilter',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.filter.originActivityId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'ppddIdTargitPpdFilter',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.filter.ppddIdTargitPpd',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdProjectPlanDetailPpd'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'targetProjectCodeFilter',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.filter.targetProjectCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'targetActivityIdFilter',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.filter.targetActivityId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prpdTypeFilter',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.filter.prpdType',
        disabled: false,
        form: {
        type: 'select'
         ,options: [
                { value: '1', text: '完成开始' },
                { value: '2', text: '开始开始' },
                { value: '3', text: '完成完成' },
                { value: '4', text: '开始完成' }
            ]
        }
        },
        {
        key: 'prpdLagTimeFilter',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.filter.prpdLagTime',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'ppddIdOriginPpd',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.ppddIdOriginPpd',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'originProjectCode',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.originProjectCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'originActivityId',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.originActivityId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdProjectPlanDetailPpd'
            ,correspondingField: 'ppdActivityId'
            ,fieldsBindingByEntityModalSelected: '{"ppddIdOriginPpd":"id","originProjectCode":"projectCode"}'
                }
        },
        {
        key: 'ppddIdTargitPpd',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.ppddIdTargitPpd',
        sortable: true,
        isDetail: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'targetProjectCode',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.targetProjectCode',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'targetActivityId',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.targetActivityId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdProjectPlanDetailPpd'
            ,correspondingField: 'ppdActivityId'
            ,fieldsBindingByEntityModalSelected: '{"ppddIdTargitPpd":"id","targetProjectCode":"projectCode"}'
                }
        },
        {
        key: 'prpdType',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.prpdType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '完成开始' },
                { value: '2', text: '开始开始' },
                { value: '3', text: '完成完成' },
                { value: '4', text: '开始完成' }
            ]
        }
        },
        {
        key: 'prpdLagTime',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.prpdLagTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesProProjectPlanDetailDepPpdd.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesProProjectPlanDetailDepPpdd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
